import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import { ToastContainer } from "react-toastify"; // Import container
import "react-toastify/dist/ReactToastify.css"; // Import default styles

// Import your main SCSS file
import "./scss/main.scss";

// Components
import ProgressBar from "./components/ui/ProgressBar";

// Import Page Components
import Introduction from "./pages/Introduction";
import Login from "./pages/Login";
import Step1Location from "./pages/Step1_Location";
import Step2Age from "./pages/Step2_Age";
import Step3PreciseLocation from "./pages/Step3_PreciseLocation";
import Step4Duration from "./pages/Step4_Duration";
import Step5Onset from "./pages/Step5_Onset";
import Step6Intensity from "./pages/Step6_Intensity";
import Step7PainType from "./pages/Step7_PainType";
import Step8Factors from "./pages/Step8_Factors";
import Step9Symptoms from "./pages/Step9_Symptoms";
import Step10History from "./pages/Step10_History";
import Step11Email from "./pages/Step11_Email";

// Result & Admin Pages
import PatientReport from "./pages/PatientReport";
import Summary from "./pages/Summary";
import AdminDashboard from "./pages/AdminDashboard";

// --- Protected Route Wrapper ---
// Checks if the user has authenticated before rendering the children
const ProtectedRoute = ({ children }) => {
  const isAuthenticated =
    localStorage.getItem("isAdminAuthenticated") === "true";

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// A wrapper component to handle animations
const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    // AnimatePresence is the key to page transition animations.
    // It detects when a component is removed from the React tree and plays an exit animation.
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Introduction />} />
        <Route path="/login" element={<Login />} />
        <Route path="/step-1" element={<Step1Location />} />
        <Route path="/step-2" element={<Step2Age />} />
        <Route path="/step-3" element={<Step3PreciseLocation />} />
        <Route path="/step-4" element={<Step4Duration />} />
        <Route path="/step-5" element={<Step5Onset />} />
        <Route path="/step-6" element={<Step6Intensity />} />
        <Route path="/step-7" element={<Step7PainType />} />
        <Route path="/step-8" element={<Step8Factors />} />
        <Route path="/step-9" element={<Step9Symptoms />} />
        <Route path="/step-10" element={<Step10History />} />
        <Route path="/step-11" element={<Step11Email />} />

        {/* Patient Result View (AI Assessment) */}
        <Route path="/patient-report" element={<PatientReport />} />

        {/* Admin/Doctor Panel Routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/report"
          element={
            <ProtectedRoute>
              <Summary />
            </ProtectedRoute>
          }
        />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <div className="app-container">
      <BrowserRouter>
        {/* ProgressBar must be inside BrowserRouter to use useLocation */}
        <ProgressBar />

        <AnimatedRoutes />

        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
